import DocTemplatesSettings from '@/pages/settings/doc-templates'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'

export const Route = createFileRoute('/(protected)/settings/doc-templates')({
  component: DocTemplatesRoute,
})

function DocTemplatesRoute() {
  // Gate the Doc Templates feature behind the `templates` flag — also covers direct
  // URL access, not just the sidebar nav item.
  const { enabled, loading } = useFeatureFlag('templates')
  if (loading) return null
  if (!enabled) return <Navigate to="/settings" />
  return <DocTemplatesSettings />
}
